// @ts-nocheck
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";

export interface PostWishListKitLineModel {
    productId: string;
    qtyOrdered: number;
    unitOfMeasure: string;
    properties?: { [key: string]: string };
}

export interface AddWishListKitLinesApiParameter extends ApiParameter {
    wishList: WishListModel;
    lines: PostWishListKitLineModel[];
}

export function addWishListLinesWithProperties(parameter: AddWishListKitLinesApiParameter) {
    const wishListLinesUri = parameter.wishList.wishListLinesUri.substr(
        parameter.wishList.wishListLinesUri.indexOf("/api/v1"),
    );

    return post(`${wishListLinesUri}/batch`, { wishListLines: parameter.lines });
}
